
export const BINARY = 'binary';
export const IMAGE = 'image';
export const JSON_ = 'json';

export interface ManifestEntry {
  src: string;
  type: 'binary' | 'image' | 'json';
  id: string;
}